import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🙂", key: "small" },
  { emoji: "😕", key: "annoying" },
  { emoji: "😬", key: "expensive" },
  { emoji: "😣", key: "veryExpensive" },
]

export default function CarsMistakeCostPage() {
  return (
    <RadioCardListPage translationKey="carsMistakeCost" options={OPTIONS} />
  )
}
